export function classNames(classObject) {
    var classNames = [];
    for (var item in classObject) {
        if (classObject[item]) {
            classNames.push(item);
        }
    }
    return classNames.join(' ');
}
